import React from 'react';
import Title from '../../uiKit/typography/title';
import SubscriptionForm from '../forms/subscriptionForm';
import { useTranslation } from 'react-i18next';

export default function FooterNewsSubscription() {
  const { t } = useTranslation('common');

  return (
    <div
      className={`max-w-1400 mx-auto p-15 bg-brand-primary rounded-[1.875rem] flex flex-col w-full [&_span]:text-white [&_p]:text-white`}>
      <Title className={'!text-white text-[3.5rem] mb-4 leading-tight'}>
        {t('titles.subscribe')}
      </Title>
      <SubscriptionForm />
    </div>
  );
}
